// extracted by mini-css-extract-plugin
export default {"banner":"I2YJeuD","content":"axlhvnB","image":"DbJcMIo","textContainer":"zfRvhiB","headline":"pEonAmn","text":"aUahu2S"};